<template>
    <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4" id="kt_datatable_payslips" style="margin-top: 13px !important; cursor:pointer">
      <thead style="background-color: #F2F3F4;">
        <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
          <th class=" px-4 ">{{$t("payslip.date")}}</th>
          <th class=" px-4 ">{{$t("payslip.amount")}}</th>
          <th>{{$t("actions")}}</th>
        </tr>
      </thead>
    </table>

</template> 

<script setup>

import {ref,onMounted,watch , nextTick} from "vue";
import {BASE_URL} from "@/services/api";
import {useStore} from "vuex";
import Ls from "@/services/ls";
import { useI18n } from 'vue-i18n'
import { useLocales } from '@/composables/locales';
import Card from "@/Modules/CRM/components/Card";
import {Theme} from "@/composables/theming";
import {useSwal} from "@/composables/useSwal";
import {useHasAbility} from "@/composables/hasAbility";
import { useFormatAmount } from "@/composables/formatAmount";
import { computed } from "vue";

const table = ref(null)
const formEdit = ref({})
const store = useStore()

const { t } = useI18n({ useScope: 'global' })
const {locale, datatableLocaleUrl} = useLocales()
const {showSwal} = useSwal()
const { can } = useHasAbility()
const { formatAmount, formatNumber } = useFormatAmount()

const currentSociety = computed(() => store.getters['offices/getSelectedCompany'])

function fetchDatas() {

const AUTH_TOKEN = Ls.get('auth.token')
  const pageLimit = Ls.get('pageLength')

table.value = $("#kt_datatable_payslips").DataTable({
  destroy : true,
  responsive: !0,
  searchDelay: 500,
  processing: !0,
  serverSide: !0,
  pageLength:pageLimit ||  5,
  lengthMenu: [5, 10, 25, 50, 75, 100 ],
  order: [[ 0, 'desc']],
  ajax: {
    url: BASE_URL+"/get/user/payslips/datatables",
    type: "GET",
    beforeSend: function (request) {
      request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
      request.setRequestHeader("Company", Ls.get('current.company'));
      },
    data:  function ( d ) {

    }
  },
  columns: [{data: "date"},{data: "paid_amount"}, {data: "Actions", responsivePriority: -1}],

  columnDefs: [
  
   
    {
        targets: -3,
        orderable: !1,
        className: "dt-center clickable",
        render:  (t, a, e, l) =>  {
          return '<span class="nameRow' + l.row + '">' + t + "</span>";

        }
    },

    {
        targets: -2,
        orderable: !1,
        className: "dt-center clickable",
        render:  (t, a, e, l) =>  {
            return '<span class="nameRow' + l.row + '">' + formatNumber(t)+ "</span>";
        }
    },

    {
      width: "16%",
      targets: -1,
      "className": "dt-center",
      title: "Actions",
      orderable: !1,
      render: (t, a, e, l) => {
        let render = '';
       
        if(true) render += `<a href="javascript:;" data-row="${l.row}" data-id="${e.id}" class="btn btn-sm btn-clean btn-icon download_btn" title="${i18n.global.t('button.delete')}"><i data-row="${l.row}" data-id="${e.id}" class="fas fa-download fs-2" style="color: ${Theme.gray}"></i></a>`;
        return render;
      },
    },

  ],
  language: {
    url:  datatableLocaleUrl.value
  }
});

}



$(document).on("click", "#kt_datatable_payslips .download_btn", (e) => {
  downloadPayslip(e.target.getAttribute('data-id'))
});


async function downloadPayslip(id){
  try {
        await store.dispatch('', id)
        reloadDatatable()
        window.toastr.success(t('notification.payslip_downloded'))
      } catch (e) {
      }
}

watch(() => locale.value, () => {
  nextTick(()=>   fetchDatas())
})

onMounted(() => {
  fetchDatas()
})

</script>
<style>
.end{
  display: flex;
  justify-content: end;
}
</style>